import React from "react";
import HomeHero from "./Home/HomeHero";
import FirstFeatures from "./Home/FirstFeatures";
import SecondFeatures from "./Home/SecondFeatures";
import IndustrySection from "./Home/IndustrySection";
import ScreenShot from "./Home/ScreenShot";
import Faq from "./Home/Faq";
import Testimonials from "./Home/Testimonials";

function Home() {
  return (
    <div>
      <HomeHero />
      <SecondFeatures />
      <FirstFeatures />
      <IndustrySection />
      <Testimonials />
      <ScreenShot />
      <Faq />
    </div>
  );
}

export default Home;
